import { Link } from "react-router-dom";
import { HiOutlineChevronDown } from "react-icons/hi";
import * as Icons from "../../assets/icons";
import { BASE_URL } from "../../api/ApiConstants";
import { useSelector } from "react-redux";

function Icon({ icon, ...props }) {
  const Icon = Icons[icon];
  return <Icon {...props} />;
}

function SidebarSubmenu({
  route,
  pathname,
  summary,
  open,
  handleDropdownMenuClick,
}) {
  const hasPermission = useSelector((state) => state?.data?.Permission?.JustCreateStockRightPaper);
  const BankAccountChangesCount = summary?.BankAccountChangesCount;
  const AddressChangesCount = summary?.AddressChangesCount;
  const LawyerRequestsCount = summary?.LawyerRequestsCount;
  const StocksRequestsCount = summary?.StocksRequestsCount;
  const badgeContainerClass =
    "p-1 min-w-fit w-6 h-6 text-white dark:text-title grid place-items-center rounded-full bg-rose-600 font-thin text-xs";

  const hasNotifications =
    BankAccountChangesCount +
      AddressChangesCount +
      LawyerRequestsCount +
      StocksRequestsCount >
    0;

  if (
    !BASE_URL.includes("https://st2api.hbbs.ir/") &&
    !BASE_URL.includes("http://api.test.hamrahbours.ir/") &&
    !BASE_URL.includes("http://apitest.hamrahbours.ir/")
  ) {
    route.routes = route.routes.filter(
      (item) => item.name !== "ساخت برگه از فایل"
    );
  }

  if (hasPermission) {
    route.routes = route.routes.filter(
      (item) => item.name === "ساخت دستی برگه" || item.name === "ساخت خودکار برگه"
    );
  }

  return (
    <li className="px-6 py-2" key={route.name}>
      <button
        className="inline-flex bg-solid hover:opacity-80 rounded-md p-2 items-center justify-between w-full text-sm font-semibold transition duration-150 text-title"
        onClick={() => handleDropdownMenuClick(route.name)}
        aria-haspopup="true"
      >
        <span className="inline-flex gap-x-2.5 items-center">
          <Icon
            className="w-5 h-5 icon transform scale-110 text-brand"
            aria-hidden="true"
            icon={route.icon}
          />
          <span className="mt-1 text-xs">{route.name}</span>
          {hasNotifications && route.name === "درخواست سهامداران" && (
            <span className="flex h-3 w-3 relative">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-600 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-rose-500"></span>
            </span>
          )}
        </span>
        <HiOutlineChevronDown
          className={`${
            open === route.name ? "rotate-180" : ""
          } icon transition-all duration-150`}
        />
      </button>
      {open === route.name && (
        <ul
          className="p-2 space-y-2 -mt-2 overflow-hidden text-xs font-medium text-gray-500 rounded-md bg-solid"
          aria-label="submenu"
        >
          {route.routes.map((route) => (
            <li
              className={`px-2 py-1 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 ${
                pathname === route.path
                  ? "text-white bg-brand rounded-md pointer-events-none"
                  : ""
              }`}
              key={route.name}
            >
              <Link
                className="w-full flex items-center justify-between "
                to={route.path}
              >
                {route.name}{" "}
                {route.path === "/bank" && BankAccountChangesCount > 0 && (
                  <div className={badgeContainerClass}>
                    <div className="transform translate-y-0.5">
                      {BankAccountChangesCount}
                    </div>
                  </div>
                )}
                {route.path === "/address" && AddressChangesCount > 0 && (
                  <div className={badgeContainerClass}>
                    <div className="transform translate-y-0.5">
                      {AddressChangesCount}
                    </div>
                  </div>
                )}
                {route.path === "/lawyerrequests" && LawyerRequestsCount > 0 && (
                  <div className={badgeContainerClass}>
                    <div className="transform translate-y-0.5">
                      {LawyerRequestsCount}
                    </div>
                  </div>
                )}
                {route.path === "/stockrequests" && StocksRequestsCount > 0 && (
                  <div className={badgeContainerClass}>
                    <div className="transform translate-y-0.5">
                      {StocksRequestsCount}
                    </div>
                  </div>
                )}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
}

export default SidebarSubmenu;
